// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".passwordGenerator {\n    margin-top: 10px;\n}\n\ninput[type=number] {\n  width: 50%\n}\n", "",{"version":3,"sources":["webpack://./js/passwordGenerator.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;EACE;AACF","sourcesContent":[".passwordGenerator {\n    margin-top: 10px;\n}\n\ninput[type=number] {\n  width: 50%\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
